import React, { useEffect, useState } from "react";
import Select from "react-select";
import { AXIOS, api_key } from "../../config";
import { useDispatch, useSelector } from "react-redux";
import { updateCoinWalletStatus ,updateCoinOfNetwrokId} from "../../store/deposit";
import { updateNetwork } from "../../store/selectedNetwork";
import { toast } from "react-toastify";

const Selectnetwork = () => {
  let userid = sessionStorage.getItem("userid");
 
  const {coinId,coinName,coinSymbol} = useSelector((state: any) => state.deposit);
  const dispatch = useDispatch();

  const [selected, setSelected] = useState({
    value: '',
    label: '',
    networkId: '',
  });
  const [options, setOptions] = useState([]);
  const handleChange = async (selectedOptions: any) => {
 
    setSelected(selectedOptions);
    dispatch(updateNetwork(selectedOptions));
  };

  // const formatOptionLabel = ({ label }) => (
  //   <div className="selected-option">{label}</div>
  // );
  // const customStyles = {
  //   menu: (provided) => ({
  //     ...provided,
  //     color: "black",
  //     backgroundColor: "white", // Customize the background color here
  //   }),
  //   option: (provided: any, state: any) => ({
  //     ...provided,
  //     backgroundColor: state.isFocused ? "lightgray" : "white", // Customize the background color here
  //     color: state.isFocused ? "black" : "inherit", // Customize the text color here
  //   }),
  // };

  const getNetworkInfo = async () => {
    const response = await AXIOS.post("/depositNetworkList", {
      api_key: api_key,
    });

    const options = response.data.data.map((network: any) => ({
      value: network.symbol,
      label: network.name,
      networkId: network._id,
    }));

    setOptions(options);
  };
  useEffect(() => {
    getNetworkInfo();
  }, []);
  const getCoinofNetwork=async()=>{
    let response=await AXIOS
       .post('getCoinOfNetwork', {
         api_key: api_key,
         name: coinName,
         symbol: coinSymbol,
         network:selected.label
 
       })
       if(response.data.status !='fail'){
        dispatch(updateCoinOfNetwrokId(response.data.data._id))
        const respons = await AXIOS.post("/getCoinWallet", {
         user_id: userid,
         coin_id: response.data.data._id,
         network_id: selected.networkId,
         api_key: api_key,
       });
        if (respons.data.showableMessage == "Wallet found") {
         dispatch(
           updateCoinWalletStatus({
             status: respons.data.showableMessage,
             walletAddress: respons.data.data[0].address,
             networkId: selected.networkId,
           })
         );
       } else {
         dispatch(
           updateCoinWalletStatus({
             status: respons.data.showableMessage,
             walletAddress: "",
             networkId: selected.networkId,
           })
         );
       }
       }
       else{
        dispatch(
          updateCoinWalletStatus({
            status: response.data.showableMessage,
            walletAddress: "",
            networkId: selected.networkId,
          })
        );
       }
   
   }
   
   useEffect(() => {
     if (selected.label !='' && coinName !=='') {
       getCoinofNetwork()
     }
 
   }, [selected,coinName]);
   
  
  return (
    <>
      <h6 className="" style={{color:'var(--text-clr)'}}>Network</h6>
      <Select
        options={options}
        value={selected}
        onChange={handleChange}
        components={{ Option: CustomOption}
      }
     
        isDisabled={coinId.length < 1}
        
      />
    </>
  );
};

export default Selectnetwork;



const CustomOption = ({ data, innerProps }) => (
  <>
  
  <div {...innerProps} className='p-2 custom-option'>
     

      {data.label}
  </div>
  </>
);
// import React, { useState, useEffect } from 'react';